import { Link } from "react-router-dom";
import { Menu, X, Cpu } from "lucide-react";
import { useEffect, useState } from "react";
import BrandWordmark from "@/components/site/BrandWordmark";

const NAV = [
  { label: "Services", href: "#services" },
  { label: "Sectors", href: "#sectors" },
  { label: "Projects", href: "#projects" },
  { label: "Clients", href: "#clients" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar({ onOpenChat }) {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-40 transition-colors duration-300 ${
        scrolled ? "bg-[#0A1F44]/85 backdrop-blur-xl border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto flex items-center justify-between px-6 lg:px-10 h-16">
        <Link to="/" data-testid="nav-logo" className="group">
          <BrandWordmark variant="compact" onDark={true} />
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              data-testid={`nav-link-${n.label.toLowerCase()}`}
              className="font-mono text-xs uppercase tracking-widest text-zinc-400 hover:text-volt transition-colors duration-150"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            data-testid="nav-open-chat"
            onClick={onOpenChat}
            className="hidden md:inline-flex items-center gap-2 px-4 py-2 btn-volt font-mono text-xs uppercase tracking-widest"
          >
            <Cpu size={14} /> Ask PCN.ai
          </button>
          <button
            className="lg:hidden p-2 border border-white/15"
            onClick={() => setOpen((s) => !s)}
            data-testid="nav-menu-toggle"
          >
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-[#0A1F44]/98 border-t border-white/10" data-testid="mobile-menu">
          <div className="flex flex-col p-6 gap-4">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                className="font-mono text-sm uppercase tracking-widest text-zinc-300 hover:text-volt"
              >
                {n.label}
              </a>
            ))}
            <button
              onClick={() => { setOpen(false); onOpenChat?.(); }}
              className="btn-volt px-4 py-2 font-mono text-xs uppercase tracking-widest inline-flex items-center gap-2 w-max"
              data-testid="mobile-open-chat"
            >
              <Cpu size={14} /> Ask PCN.ai
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
